import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";

import SimpleModal from "components/SimpleModal";
import { createErrorSelector, createLoadingSelector } from "store/selectors";
import { enableCompany } from "actions/adminActions";
import { adminConstants } from "actions/types";
import { toast } from "react-toastify";
import { get } from "lodash";
import type { Company } from "types/models";
import type { RootState } from "types/state";

const isFetchingSelector = createLoadingSelector(adminConstants.ENABLE_COMPANY);
const errorSelector = createErrorSelector(adminConstants.ENABLE_COMPANY);

const mapStateToProps = (state: RootState) => {
  return {
    isFetching: isFetchingSelector(state),
    error: errorSelector(state),
  };
};

const mapDispatchToProps = {
  enableCompany,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  onClose: (clickingOutsideModal?: boolean) => void;
  onSuccess: (currentState: string) => void;
  company: Company;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

class EnableCompanyModal extends React.PureComponent<Props> {
  _enableCompany = () => {
    void this.props
      .enableCompany(
        this.props.client as ApolloClient<object>,
        this.props.company.id
      )
      .then((result) => {
        if (result.success) {
          this.props.onSuccess(get(result, "data.state", "") as string);
          toast.success("Successfully enabled company.");
        }
      });
  };

  render() {
    return (
      <SimpleModal
        show={true}
        onClose={this.props.onClose}
        onSubmit={this._enableCompany}
        title="Enable Company"
        buttonText="Enable"
        closeButtonText="Cancel"
        showCloseButton={true}
        isXhrRequest={true}
        error={this.props.error}
        isFetching={this.props.isFetching}
      >
        <p>
          {"Are you sure you want to re-enable "}
          <b>{this.props.company.name}</b>
          {"?"}
        </p>
        <ul>
          <li>{"The company admin will regain access."}</li>
          <li>
            {
              "Other admins and agents will be able to log in again, but an admin must unlock each of them before they can reach this company."
            }
          </li>
          <li>
            {
              "Groups, bank accounts, and employee links that were removed when the company was disabled are not restored."
            }
          </li>
        </ul>
      </SimpleModal>
    );
  }
}

export default connector(withApollo<Props>(EnableCompanyModal));
